import React, { useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const AddEducationActivity = ({
  getUserCv,
  userDataId,
  handleCloseEducationActivity,
  showEducationActivity,
  educationData,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  const [activity, setActivity] = useState("");
  const [display, setDisplay] = useState(false);
  console.log("educationData", educationData);

  const [formChanged, setFormChanged] = useState(false); // Track if form is modified
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Handle changes and mark form as modified
  const handleFieldChange = (setter, value) => {
    setter(value);
    // setFormChanged(true); // Enable Submit button
    setFormChanged(value.trim() !== ""); // Enable button only if input has value
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    setIsSubmitting(true); // Disable the button during submission
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      eduId: educationData.usrDataEductnId,
      eduActvtyId: 0,
      activity: activity,
    };
    console.log("body====>", body);
    // if (achivement === "" || achivementDate === "") {
    //   toast.error("Please fill all the required fields");
    // } else {
    try {
      const res = await axios.post("/Resume/AddEducationActivity", body);
      toast.success(res.data.message);
      resetForm();
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    } finally {
      setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
    }
    // }
  };

  const resetForm = () => {
    handleCloseEducationActivity();
    getUserCv();
    setActivity("");
    setDisplay(false);
    setFormChanged(false); // Disable the button after update
  };

  const handleCloseEducationActivityFunction = () => {
    resetForm(); // Call resetForm when closing the modal
    handleCloseEducationActivity();
  };


  return (
    <Modal
      show={showEducationActivity}
      onHide={handleCloseEducationActivityFunction}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Add education activity</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseEducationActivityFunction}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Activity{" "}<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={activity}
                // onChange={(e) => setActivity(e.target.value)}
                onChange={(e) => handleFieldChange(setActivity, e.target.value)} // Track changes
                placeholder="Enter activity"
                className="Dark-Input-from-group"
              />
              {display && !activity ? (
                <span className="error_msg_lbl">Add activity </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
            onClick={handleSubmit}
						style={{cursor: formChanged ? "pointer" : "default"}}
            >
              <a href="#/"
                // onClick={handleSubmit}
                className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                disabled={!formChanged || isSubmitting}
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }} >
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddEducationActivity;
